<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ລວມບິນ ຈັດຊື້ ປະຈຳວັນ
          </h2>
        </div>
      </div>
      
          <div class="columns">
            <div class="column" style="padding-right:50px;">
              <b-field grouped>
                <b-field>
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="startMarketBatchDate"
                  >
                  </b-datepicker>
                </b-field>
              </b-field>
            </div>
            <div class="column" style="padding-right:50px;">
              <b-field grouped>
                <b-field>
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="endMarketBatchDate"
                  >
                  </b-datepicker>
                </b-field>
              </b-field>
            </div>


            <div class="column">
              <b-field>
                <b-button
                  class="btn-group-margin"
                  type="is-info"
                  @click="allMarketBatchStatus()"
                  >ເບິ່ງຂໍ້ມູນ
                </b-button>
              </b-field>
            </div>
            <div class="column"></div>
          </div>
          <b-field>
            <b-tabs
              v-model="activeSub2TabMarketBatch"
              v-if="roleid == 6 || roleid == 7">
              <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ/ ວັນທີອອກຕະຫຼາດ">
                

                <div class="columns">
                  <div class="column" style="padding-right:50px;">
                    <b-field grouped>
                      <b-field label=""> </b-field>
                      <Multiselect
                        placeholder="ລຽນຮ້ານຕາມ...."
                        v-model.trim="selectedCompanyby"
                        label="NAME"
                        track-by="ID"
                        :options="companyByList" 
                        @input="onSelectedCompanyby"
                      >
                      </Multiselect>  
                    </b-field>
                  </div>

                  <div class="column" style="padding-right:50px;">
                    
                    <b-button v-if="isAllQuotation ==1"
                      class="btn-group-margin"
                      type="is-warning"
                      size="is-small"
                      @click="gotoJoinBillB2Blist"  
                      >ເບິ່ງລາຍການຮ້ານ  
                    </b-button>
                    <!-- <b-button v-else
                      class="btn-group-margin"
                      type="is-success"
                      size="is-small"
                      @click="getQuotationDateList"  
                      >ດືງໃບສົ່ງເຄື່ອງລວມ  
                    </b-button> -->
                    
                  </div>
                </div>

                <table class="table is-fullwidth is-narrow is-small" v-if="isAllQuotation == 0">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດສັ່ງຊື້
                      </th>
                      <th class="has-text-left " width="10%">
                        BatchID
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີສົ່ງສິນຄ້າ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສາຍທາງ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຊື່ລູກຄ້າ
                      </th>
                      
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນເງິນ
                      </th>
                      <th class="has-text-centered " width="20%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in allquotationformarketdatelist"
                      :key="data.PURCHASEID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PURCHASEID }}
                      </td>
                      <td>
                        {{ data.MARKETBATCHID }}
                      </td>
                      
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-centered">
                        {{ data.ROUTE }}  
                      </td>
                      <td class="has-text-left">
                        {{ data.COMPANY }}
                      </td>
                      
                      <td class="has-text-right">
                        {{ data.TOTAL | formatNumberLocal }}  
                      </td>
                      <td class="has-text-centered">
                        <b-field class="has-addons-centered" > 
                          <b-button v-if="data.MARKETBATCHSTATUS == 0"
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="openContractDateForm(6, data)"
                            >ລາຍລະອຽດ
                          </b-button>
                          <b-button v-if="data.MARKETBATCHSTATUS == 0"
                            class="btn-group-margin"  
                            type="is-primary"
                            size="is-small"
                            @click="joinMarketBatch(1,data)"
                            >ກົດເພື່ອລວມບິນ
                          </b-button>
  
                          <b-button v-else-if="data.MARKETBATCHSTATUS == 1"
                            class="btn-group-margin"
                            type="is-warning"
                            size="is-small"
                            @click="joinMarketBatch(0, data)"
                            >ຢູ່ຂັ້ນຕອນລວມບິນ
                          </b-button>
                          <b-button v-else-if="data.MARKETBATCHSTATUS == 2"
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="joinMarketBatch(0, data)"
                            >ລວມບິນແລ້ວ
                          </b-button>
                        </b-field>
                          
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-field v-if="isAllQuotation == 1"> 
                  <div>
                        <b-field
                          v-for="(quotation) in allquotationdatelist"
                          :key="quotation.PURCHASEID"
                        >
                          <div class="columns">
                            <div class="column">
                              <field style="font-size: 20px; font-weight: bold;">{{quotation.COMPANY}}</field><br>
                              ວັນທີ: <field style="font-size: 16px; font-weight: bold;">{{dateFormatter(quotation.REDATE)}}</field><br>
                              ເລກທີບິນ: <field style="font-size: 16px; font-weight: bold;">{{quotation.PURCHASEID}}</field><br>
                              
                              <b-field v-if="quotation.full && quotation.full.length !== undefined && quotation.full.length !=0">   
                                ລາຍການສິນຄ້າ ທີ່ໄດ້ຄົບ
                              </b-field>
                              <table
                                class="table is-fullwidth is-narrow is-small"
                                v-if="quotation.full && quotation.full.length !== undefined && quotation.full.length !=0"
                              >
                                <thead>
                                  <tr style="height: 50px;">
                                    <th
                                      class="has-text-centered set-border"
                                      width="5%"
                                      style="vertical-align: middle;" 
                                    >
                                      #
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="20%"
                                      style="vertical-align: middle;"
                                    >
                                      ສິນຄ້າ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ສັ່ງ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ໄດ້ຮັບ
                                    </th>
                                    
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ໝາຍເຫດ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(data, index) in quotation.full"
                                    :key="data.PRODUCTID_SUB"
                                  >
                                    <td class="has-text-centered set-border">{{ index + 1 }}</td>

                                    <td class="set-border">
                                      <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}      
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BAMOUNT | formatNumberLocal }}     
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                                    </td>

                                  
                                    <td class="has-text-right set-border"></td>
                                  </tr>
                                </tbody>

                              </table>

                              <b-field v-if="quotation.some && quotation.some.length !== undefined && quotation.some.length !=0 ">
                                ລາຍການສິນຄ້າ ທີ່ໄດ້ບາງສ່ວນ  
                              </b-field>
                              <table
                                class="table is-fullwidth is-narrow is-small"
                                v-if="quotation.some && quotation.some.length !== undefined && quotation.some.length !=0"
                              >
                                <thead>
                                  <tr style="height: 50px;">
                                    <th
                                      class="has-text-centered set-border"
                                      width="5%"
                                      style="vertical-align: middle;"
                                    >
                                      #
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="20%"
                                      style="vertical-align: middle;"
                                    >
                                      ສິນຄ້າ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ສັ່ງ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ໄດ້ຮັບ
                                    </th>
                                    
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ໝາຍເຫດ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(data, index) in quotation.some"
                                    :key="data.PRODUCTID_SUB"
                                  >
                                    <td class="has-text-centered set-border">{{ index + 1 }}</td>

                                    <td class="set-border">
                                      <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}      
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BAMOUNT | formatNumberLocal }}     
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                                    </td>

                                   
                                    <td class="has-text-right set-border"></td>
                                  </tr>
                                </tbody>

                              </table>

                              <b-field v-if="quotation.zero && quotation.zero.length !== undefined && quotation.zero.length !=0">
                                ລາຍການສິນຄ້າ ທີ່ບໍ່ໄດ້  
                              </b-field>  
                              <table
                                class="table is-fullwidth is-narrow is-small"
                                v-if="quotation.zero && quotation.zero.length !== undefined  && quotation.zero.length !=0"
                              >
                                <thead>
                                  <tr style="height: 50px;">
                                    <th
                                      class="has-text-centered set-border"
                                      width="5%"
                                      style="vertical-align: middle;"
                                    >
                                      # 
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="20%"
                                      style="vertical-align: middle;"
                                    >
                                      ສິນຄ້າ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ສັ່ງ
                                    </th>
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ຈຳນວນ <br> ທີ່ໄດ້ຮັບ
                                    </th>
                                   
                                    <th
                                      class="has-text-centered set-border"
                                      width="10%"
                                      style="vertical-align: middle;"
                                    >
                                      ໝາຍເຫດ
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(data, index) in quotation.zero"
                                    :key="data.PRODUCTID_SUB" 
                                  >
                                    <td class="has-text-centered set-border">{{ index + 1 }}</td>

                                    <td class="set-border"> 
                                      <span v-if="data.ISCLIAMED==1" style="font-weight: bold;"> (ສິນຄ້າເຄຼມ) </span> {{ data.PRODUCTNAME }}      
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BAMOUNT | formatNumberLocal }}     
                                    </td>
                                    <td class="has-text-right set-border">
                                      {{ data.B2BGETAMOUNT | formatNumberLocal }}  
                                    </td>

                                   
                                    <td class="has-text-right set-border"></td>
                                  </tr>
                                </tbody>

                              </table>
                              <div>
                                #######################
                              </div>
                            </div>
                          </div>
                        </b-field>
                  </div>
                    
           



                  
                    
                </b-field>
              </b-tab-item>
              <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                <div class="columns">
                  <div class="column">
                    BatchID : {{ selectedMarketOrderBatchID}}<br>
                    ຊື່ລູກຄ້າ: {{ marketBatchB2BName }} <br />
                    ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedMarketBatchDate) }}
                  </div>
                </div>

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ  
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in marketbatchdetaillist"
                      :key="data.PRODUCTID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>

                      <td>
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td class="has-text-right">
                        
                        {{ data.MARKETAMOUNT | formatNumberLocal }}
                       

                      </td>
                      
                    
                     
                    </tr>
                  </tbody>
                  
                </table>
              </b-tab-item>

              <b-tab-item label="ລວມບິນຈັດຊື້">


                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>

                      <th class="has-text-left " width="15%">
                        BatchID
                      </th>
                      <th class="has-text-left " width="15%">
                        ວັນທີສົ່ງເຄື່ອງ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນບໍລິສັດ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈຳນວນ<br>ສິນຄ້າ / ລາຍການ
                      </th>
                      <th class="has-text-right " width="15%">
                        ຈັດການ
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in allMarketBillDateList"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETBATCHID }}
                      </td>
                      <td>
                        {{ dateFormatter(data.REDATE) }}
                      </td>
                      <td class="has-text-right">
                        
                        {{ data.COUNTCOMPANY | formatNumberLocal }}
                       
                      </td>
                      <td class="has-text-right">
                        
                        {{ data.COUNTPRODUCT | formatNumberLocal }} / {{ data.COUNTSUMPRODUCT | formatNumberLocal }}

                      </td>
                      
                      <td class="has-text-right">
                        
                        <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="marketBillDetail(data.MARKETBATCHID,1)"
                            >ລາຍລະອຽດ 
                        </b-button>

                      </td>
                     
                    </tr>
                  </tbody>
                  
                </table>
              </b-tab-item>

              <b-tab-item label="ລາຍລະອຽດບິນຈັດຊື້">
                <div class="columns">
                  <div class="column">
                    BatchD: {{selectedMarketBatchID}} <br>
                    ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedMarketBatchDate) }}
                    
                    
                  </div> 
                </div>

                <b-tabs
                  v-model="activeSub3TabJoinOrder"
                  v-if="roleid == 6 || roleid == 7">
                  <b-tab-item label="ລາຍການຈັດຊື້ລວມ">
                    <div class="columns">
                      <div class="column" style="padding-right:50px;">
                        <b-field grouped>
                          <b-field label=""> </b-field>
                          <Multiselect
                            placeholder="ລຽນອໍເດີ້ຕາມ...."
                            v-model.trim="selectedOrderby"
                            label="NAME"
                            track-by="ID"
                            :options="orderByList" 
                            @input="onSelectedOrderby"
                          >
                          </Multiselect>
                        </b-field>
                      </div>
                      <div class="column" style="text-align: right;">
          
                        <b-button v-if="checkmarketBuyProduct ==0 && orderBySet !=3 && marketbatchstatus == 0"   
                          class="btn-group-margin"
                          type="is-primary" 
                          @click="asignMarket(allMarketBillDateDetail)"
                          >ບັນທຶກຕະຫຼາດ 
                        </b-button> 
                        <b-button v-if="checkmarketBuyProduct==0 && orderBySet !=3 && marketbatchstatus == 1"   
                          class="btn-group-margin"
                          type="is-danger" 
                          @click="cancelJoinMarketBatchOrder(selectedMarketBatchID)"
                          >ຍົກເລີກການລວມບິນ
                        </b-button> 
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column" >
                      
                      </div>
                      <div class="column" >
                      
                      </div>
                      <div class="column" >
                      
                      </div>
                      <div class="column" style="text-align:right;" >
                        <table class="table is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-right " width="40%">
                                ຜູ້ຊື້
                              </th>
                              <th class="has-text-right " width="20%">      
                                ຈຳນວນ
                              </th>
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data) in purchaserProduct"
                              :key="data.NAME"
                            >
                              <td class="has-text-right">
                                {{ data.NAME }}  
                              </td>
                              <td class="has-text-right" style="font-weight: bold; padding-left: 10px">
                                <span v-if="data.counttemp != data.countmarket" style="background-color:red; color: white; padding: 2px 2px 2px 2px"> 
                                  {{ data.counttemp }} / {{data.countmarket}}  
                                </span>  
                                <span v-else>
                                  {{ data.counttemp }} / {{data.countmarket}}
                                </span>  
                                  
                              </td>  
                            </tr>
                          </tbody>
                          
                        </table>
                    </div>
                  </div>
                  <div class="columns" v-if="orderBySet ==1">   
                    <div class="column" >
                      <b-field grouped>
                        <b-field >
                          <b-input 
                            v-model.trim="productSearch"  
                            type="text"
                            style="width: 300px;"
                          />
                        </b-field>
                        <b-field >
                          <b-button   
                            class="btn-group-margin"
                            type="is-primary" 
                            @click="searchProductMarket()"
                            >ຄົ້ນຫາ
                          </b-button> 
                        </b-field>
                        <b-field >
                          <b-button 
                            class="btn-group-margin"
                            type="is-warning" 
                            @click="searchStockProductMarket()"         
                            >ເຄື່ອງທີ່ມີຢູ່ສາງ
                          </b-button> 
                        </b-field>
                        <b-field >
                          <b-button 
                            class="btn-group-margin"
                            type="is-info" 
                            @click="searchAllProductMarket()"
                            >ທັງໝົດ
                          </b-button> 
                        </b-field>
                      </b-field>
                      
                    </div>
                    <div class="column" >

                    </div>
                  </div>

                  <div class="columns" v-if="orderBySet ==4">       
                    <div class="column" >
                      <b-field >
                        <Multiselect
                          placeholder="ເລືອກ Vender"
                          v-model.trim="selectedBuyVender"
                          label="NAME"
                          track-by="ID"
                          :options="buyVenderList" 
                          @input="onSelectedBuyVender"
                        >
                        </Multiselect>
                      </b-field>
                      
                    </div>
                    <div class="column" >
                     
                      <b-field v-if="countmarketbatch == 0">
                        <Multiselect
                          placeholder="ເລືອກຜູ້ຊື້"
                          v-model.trim="selectedPurchaser"
                          label="NAME"
                          track-by="ID"
                          :options="purchaserList" 
                        >
                        </Multiselect>
                      </b-field>
                    </div>
                    <div class="column" >
                        <b-button  v-if="countmarketbatch == 0"
                            class="btn-group-margin"
                            type="is-danger" 
                            @click="asignMarketByVender_temp()"
                            >ມອບສິນຄ້າ
                          </b-button> 
                    </div>
                  </div>

                    
                    <!-- <table class="table is-fullwidth is-narrow is-small" v-if="1==1"> -->
                      <table class="table is-fullwidth is-narrow is-small" v-if="[1,5].includes(orderBySet)">   
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="2%">#</th>

                          <th class="has-text-left " width="15%">
                            ລາຍການ
                          </th>
                          <th class="has-text-right " width="5%">      
                            <span v-if="orderBySet==1 || orderBySet ==5">ທີ່ຕ້ອງການ</span>
                            <span v-else>ທີ່ມອບ</span>
                          </th>
                          <th class="has-text-centered " width="40%">
                            ຜູ້ຮັບຜິດຊອບ
                          </th>
                          <th class="has-text-centered " width="5%">
                            ລາຍລະອຽດ
                          </th>
                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in allMarketBillDateDetail"
                          :key="data.PURCHASEMARKETPREPAREID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
  
                          <td>
                            <span v-if="data.OKFEE!=1" style="font-weight: bold;">
                              <span :style="{ color: data.STOCKQUANTITY != null ? 'red' : 'inherit' }">
                                {{ data.PRODUCTID }} - {{ data.PRODUCTNAME }}
                              </span>
                            </span><br>
                            <span v-if="data.OKFEE==1" style="font-weight: bold; color: green;">{{ data.PRODUCTID }} - {{ data.PRODUCTNAME }}</span><br>
                            
                            <b-field v-if="data.D1_PRICE && data.OKFEE!=1">
                              <span style="color:#495057; margin-left: 0px"> {{data.D1_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D1_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D1_PRICE}}</span>   
                            </b-field>
                            <b-field v-if="data.OKFEE!=1">
                              <span style="color:#495057; margin-left: 0px"> {{data.D2_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D2_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D2_PRICE}}</span>   
                            </b-field>
                            <b-field v-if="data.OKFEE!=1">  
                              <span style="color:#495057; margin-left: 0px"> {{data.D3_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D3_BUYER}}</span>    
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D3_PRICE}}</span>        
                            </b-field>
                            <b-field v-if="data.OKFEE!=1">
                              <span style="color:#495057; margin-left: 0px"> {{data.D4_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D4_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D4_PRICE}}</span>   
                            </b-field>
                            <b-field v-if="data.OKFEE!=1">
                              <span style="color:#495057; margin-left: 0px"> {{data.D5_DATE}}</span>   
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D5_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D5_PRICE}}</span>     
                            </b-field>
                            

                          </td>
                          <td class="has-text-right">
                           
                            {{ data.QUANTITY }}  {{data.UNIT}}
                          </td>  
                          <td class="has-text-left" :style="    
                                  { backgroundColor: 
                                  parseFloat(data.QUANTITY_ASSIGNE) != parseFloat(data.QUANTITY) && data.OKFEE !=1  ? '#ed9fa8' : 'transparent'}  
                          ">
                            <b-field v-if="data.MARKETNAME === null">  
                              
                                
                              <b-field v-for="item in data.PURCHASER" :key="item.PURCHASERID">
                                <b-field v-if="data.OKFEE !=1">
                                  <b-button
                                    class="btn-group-margin"
                                    type="is-success"  
                                    size="is-small"
                                    @click="asignMarket_temp(data, item.PURCHASERID)"
                                    ><span style="font-size:16px">{{ item.PURCHASER }} </span>
                                  </b-button>
                                </b-field>
                                <b-field v-else>
                                  &#9989; {{ item.PURCHASER }}
                                </b-field>
                                  
                              </b-field>  
                            </b-field>
                            <b-field v-if="data.MARKETASSIGNSTATUS==0 && data.OKFEE !=1" style="padding-left: 15%">  
                              <b-button
                                  class="is-small btn-group-margin"
                                  type="is-danger"
                                  size="is-small"
                                  @click="cancelAsignMarket_temp(data, 1)"    
                              >X
                              </b-button> {{ data.MARKETNAME }}
                              
                            </b-field>
                            <b-field v-else style="padding-left: 15%"> 
                              <span v-if="data.MARKETNAME ">
                                &#9989; {{ data.MARKETNAME }}
                              </span> 
                            </b-field>
                          </td>  
  

                          <td class="has-text-centered">
                            <b-button v-if="data.OKFEE!=1"   
                              class="btn-group-margin"
                              type="is-info" 
                              size="is-small"
                              @click="joinOrderDetail(selectedMarketBatchID, data.PURCHASEMARKETPREPAREID, data.PRODUCTID, data.QUANTITY, selectedMarketBatchDate, data.UNIT)"
                              >ລາຍລະອຽດ
                            </b-button> 
                                 
                          </td>
                        
                        
                        </tr>
                      </tbody>
                      
                    </table>

                    <table class="table is-fullwidth is-narrow is-small" v-else-if="orderBySet ==2">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="2%">#</th>

                          <th class="has-text-left " width="15%">
                            ລາຍການ
                          </th>
                          <th class="has-text-right " width="5%">      
                            <span v-if="orderBySet==1">ທີ່ຕ້ອງການ</span>
                            <span v-else>ທີ່ມອບ</span>
                          </th>
                          <th class="has-text-centered " width="40%">
                            ຜູ້ຮັບຜິດຊອບ
                          </th>
                          <th class="has-text-centered " width="5%">
                            ລາຍລະອຽດ
                          </th>
                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in allMarketBillDateDetail"
                          :key="data.PURCHASEMARKETPREPAREID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
  
                          <td>
                            <span style="font-weight: bold;">{{ data.PRODUCTID }} - {{ data.PRODUCTNAME }}</span><br>
                            
                            <b-field v-if="data.D1_PRICE">
                              <span style="color:#495057; margin-left: 0px"> {{data.D1_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D1_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D1_PRICE}}</span>   
                            </b-field>
                            <b-field>
                              <span style="color:#495057; margin-left: 0px"> {{data.D2_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D2_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D2_PRICE}}</span>   
                            </b-field>
                            <b-field>  
                              <span style="color:#495057; margin-left: 0px"> {{data.D3_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D3_BUYER}}</span>    
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D3_PRICE}}</span>        
                            </b-field>
                            <b-field>
                              <span style="color:#495057; margin-left: 0px"> {{data.D4_DATE}}</span> 
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D4_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D4_PRICE}}</span>   
                            </b-field>
                            <b-field>
                              <span style="color:#495057; margin-left: 0px"> {{data.D5_DATE}}</span>   
                              <span style="color:#495057; margin-left: 10px"> &nbsp; {{data.D5_BUYER}}</span> 
                              <span style="color: red; margin-left: 10px">&nbsp; {{data.D5_PRICE}}</span>     
                            </b-field>
                            

                          </td>
                          <td class="has-text-right">   
                           
                            {{ data.QUANTITY | formatNumberLocal }}  {{data.UNIT}}
                                  
                          </td>  
                          <td class="has-text-left">    
                            
                            <b-field v-if="data.MARKETASSIGNSTATUS==0" style="padding-left: 15%">  
                               {{ data.MARKETNAME }}
                              
                            </b-field>
                            <b-field v-else style="padding-left: 15%"> 
                              <span v-if="data.MARKETNAME ">
                                &#9989; {{ data.MARKETNAME }}
                              </span> 
                            </b-field>
                          </td>  
  

                          <td class="has-text-centered">
                            
                            <b-button
                              class="btn-group-margin"
                              type="is-info" 
                              size="is-small"
                              @click="joinOrderDetail(selectedMarketBatchID, data.PURCHASEMARKETPREPAREID, data.PRODUCTID, data.QUANTITY, selectedMarketBatchDate, data.UNIT)"
                              >ລາຍລະອຽດ
                            </b-button> 
                                 
                          </td>
                        
                        
                        </tr>
                      </tbody>
                      
                    </table>

                    <table class="table is-narrow is-small" v-else-if="orderBySet ==3" width="70%">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">#</th>

                          <th class="has-text-left " width="40%">
                            ສິນຄ້າຍ່ອຍ
                          </th>
                          <th class="has-text-right " width="20%">      
                            ຈຳນວນ
                          </th>
                          <th class="has-text-left " width="40%">      
                            ຮ້ານ
                          </th>
                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in allMarketBillDateDetail"
                          :key="data.ID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>

                          <td class="has-text-left">
                            {{ data.PRODUCTNAME_SUB }}  
                          </td>
                          <td class="has-text-right" style="font-weight: bold; padding-left: 10px">
                              {{ data.QUANTITY*data.SUBUNIT | formatNumberLocal }} {{data.UNIT}}
                          </td>  
                          <td class="has-text-left">
                          
                            {{ data.COMPANY }}
                        </td>  

                         
                        
                        </tr>
                      </tbody>
                      
                    </table>

                    

                    <table class="table is-narrow is-small" v-else-if="orderBySet ==4" style="width: 50%;">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="1%">#</th>

                          <th class="has-text-left " width="5%">
                            Vender
                          </th>
                          <th class="has-text-left " width="20%">      
                            ສິີນຄ້າ
                          </th>
                          <th class="has-text-right " width="20%">      
                            ຈຳນວນ
                          </th>
                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in allMarketBillDateDetail"
                          :key="data.ID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>

                          <td class="has-text-left">
                            {{ data.VENDERNAME }}  
                          </td>
                          <td class="has-text-left">
                            {{ data.PRODUCTNAME_SUB }}  
                          </td> 
                          <td class="has-text-right">
                            <span style="color: red; font-weight: bold;"> {{ data.QUANTITY }} </span> {{data.UNIT}}  
                          </td>
                        </tr>
                      </tbody>
                      
                    </table>

                  </b-tab-item>
                  <b-tab-item label="ລາຍລະອຽດ">
                    <div class="columns" style="text-align: right; ">
                      <div class="column">

                      </div>
                      <div class="column">
                        
                      </div>
                          
                    </div>
                    <div class="columns">
                      <div class="column">
                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="2%">#</th>

                              <th class="has-text-left " width="15%">
                                ຊືຶ່ຮ້ານ 
                              </th>
                              <th class="has-text-left " width="30%">
                                ລາຍການ
                              </th>
                              <th class="has-text-centered " width="5%">
                                ຈຳນວນ<br>
                                ທີ່ຕ້ອງການ
                              </th>
                             
                             
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in allMarketBillDateDetailOrderbycustomer"
                              :key="data.PRODUCTID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td>
                                {{ data.COMPANY }}
                              </td>
                              <td>
                                {{ data.PRODUCTID }}-{{ data.PRODUCTID_SUB }} | {{ data.PRODUCTNAME_SUB }}
                              </td>
                              <td class="has-text-right">  
                                
                                {{ data.QUANTITY*data.SUBUNIT | formatNumberLocal }} {{ selectedProductUnit }}
                              

                              </td>

                              
                            
                            
                            </tr>
                          </tbody>
                          
                        </table>

                        <table class="table is-fullwidth is-narrow is-small">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="2%">#</th>

                              <th class="has-text-left " width="30%">
                                ລາຍການ
                              </th>
                              <th class="has-text-right " width="5%">
                                ຈຳນວນ<br>
                                ທີ່ຕ້ອງການ
                              </th>
                              <th class="has-text-right " width="5%">
                                ຈຳນວນ<br>
                                ທີ່ມອບ
                              </th>
                              <th class="has-text-centered " width="15%">
                                ເລືອກຜູ້ຮັບຜິດຊອບ
                              </th>
                             
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in allMarketBillDateDetailOrder"
                              :key="data.PRODUCTID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td>
                                {{ data.PRODUCTID }}-{{ data.PRODUCTID_SUB }} | {{ data.PRODUCTNAME_SUB }}
                              </td>
                              <td class="has-text-right">  
                                
                                {{ data.QUANTITY*data.SUBUNIT | formatNumberLocal }} {{ selectedProductUnit }}
                              

                              </td>
                              

                              <td class="has-text-right">
                                <b-field v-if="parseFloat(marketProductTempQuantity) < parseFloat(data.QUANTITY)"  >
                                  <b-input 
                                    v-model.trim="data.MARKETQUANTITY"
                                    type="number"
                                    min="0"
                                    pattern="[0-9]+"
                                    style="width: 100px;"
                                  />
                                </b-field>  
                                 
                                <b-field v-else>
                                  {{ marketProductTempQuantity | formatNumberLocal }} {{ selectedProductUnit }}
                                </b-field>
                                  
                              </td>

                              <td class="has-text-centered">
                                <b-field v-if="parseFloat(marketProductTempQuantity) < parseFloat(data.QUANTITY)">    
                                  <Multiselect 
                                    placeholder="ຜູ້ຮັບຜິດຊອບ"    
                                    v-model.trim="data.SELECTEDMARKET"  
                                    label="NAME"  
                                    track-by="ID"
                                    :options="marketList"
                                    @input="asignMarket_temp_inDetail(data, index)"    
                                    
                                   
                                  >  
                                  </Multiselect>
                                </b-field>
                                <b-field v-else style="padding-left: 15%">
                                  <b-button v-if="productMarketID== 0 && marketProductTempQuantity > 0 && data.LOCKED !=1"
                                      class="is-small btn-group-margin"
                                      type="is-danger"
                                      size="is-small"
                                      @click="cancelAsignMarket_temp(data, 2)"         
                                  > X  
                                  </b-button> 
                                </b-field>
                              </td>
                              
                            
                            
                            </tr>
                          </tbody>
                          
                        </table>

                        <table class="table  is-narrow is-small" style="width: 400px;">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">#</th>

                              <th class="has-text-left " width="20%">
                                ຜູ້ຮັບຜິດຊອບ
                              </th>
                              <th class="has-text-right " width="30%">
                                ຈຳນວນມອບ
                              </th>
                              <th class="has-text-right " width="40%">
                                ຈຳນວນລວມ(ສາງ)
                              </th>
                             
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in allMarketBillDateDetailPurchaserProduct"
                              :key="data.ID"
                            >  
                              <td class="has-text-centered">{{ index + 1 }}</td>

                              <td class="has-text-left">
                                {{ data.MARKETNAME }}
                              </td>
                              <td class="has-text-right">
                                {{ data.ASSIGNQUANTITY | formatNumberLocal }} {{ data.ASSIGNUNIT }}
                              </td>
                              <td class="has-text-right">
                                {{ data.TOTAL | formatNumberLocal }} {{ data.STOCKUNIT }}  
                              </td>

                              
                              
                            
                            
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="3" class="has-text-right">
                                ລວມ
                                {{ allMarketBillDateDetailPurchaserProduct.length | formatNumberLocal }}
                                ລາຍການ
                              </th>
                              <th class="has-text-right">
                                {{  
                                    _.sumBy(allMarketBillDateDetailPurchaserProduct, (i) => i["TOTAL"] * 1)  
                                    | formatNumberLocal  
                                }} 
                              </th>
                            </tr>
                          </tfoot>
                        </table>

                        <table class="table  is-narrow is-small" style="width: 400px;">
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">  </th>  

                              <th class="has-text-left " width="20%">
                                
                              </th>
                              <th class="has-text-right " width="30%">
                                
                              </th>
                              <th class="has-text-right " width="40%">
                               ຍັງບໍ່ພໍ
                              </th>
                             
                            
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th class="has-text-centered " width="5%"></th>

                              <th class="has-text-left " width="20%">
                               
                              </th>
                              <th class="has-text-right " width="30%">
                               
                              </th>
                              <th class="has-text-right " width="40%">     
                                {{ _.sumBy(allMarketBillDateDetailOrder, (i) => i["QUANTITY"] * i["SUBUNIT"] * 1)  - _.sumBy(allMarketBillDateDetailPurchaserProduct, (i) => i["TOTAL"] * 1)  }}
                              </th>
                             
                            
                            </tr>
                          </tbody>
                          
                        </table>
                        
                      </div>

                    </div>
                        

                  </b-tab-item>
                </b-tabs>

                

                
              </b-tab-item>

              

            </b-tabs>
          </b-field>
        
    </div>
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import { BFormSelect } from 'bootstrap-vue'

export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],
      // inactivemarkets: [],
      b2buserid: null,
      b2busername: null,

      activeTab: 0,

      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,

      activeFormTypeTab: 0,

      activeSub2TabWait: 0,
      activeSub2TabPrepare: 0,
      activeSub2TabQuotation: 0,
      activeSub2TabInvoice: 0,
      activeSub2TabReceipt: 0,
      activeSub2TabProfit: 0,
      activeB2BTab: 0,
      activeB2BStockTab: 0,
      activeSub2TabAllOrders: 0,
      activePaymentData: 0,
      activeSub2TabMarketBatch: 0,

      activeSub3TabJoinOrder: 0,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,
      contractid: null,
      contractno: null,
      subcontractno: null,
      selectedcontractno: null,
      selectedsubcontractno: null,
      countryList: [],
      SelectedCountry: null,
      ProvinceList: [],
      SelectedProvince: null,
      district: null,
      village: null,
      contractstatus: null,
      contractdate: null,
      contractdetail: null,
      contractlist_waittoapprove: [],
      contractlist_waitinvoice: [],
      contractlist_waitreceipt: [],
      contractlist_receipt: [],
      isContractProductList: false,
      waitdatelist: [],
      preparedatelist: [],
      quotationdatelist: [],
      invoicedatelist: [],
      receiptdatelist: [],
      profitdatelist: [],
      profitLostDateList: [],
      profitProfitDateList: [],
      profiProductPriceList: [],
      profitAllDateList: [],
      allordersdatelist: [],
      paymentdatalist: [],
      b2bpaymentdatalist: [],
      b2bpaymentdatalistdetail: [],
      allquotationformarketdatelist: [],

      profitByDate: [],

      activeQuotaProgressTab: 0,

      productBuyPrice: [],
      productBuyPriceHistory: [],

      DppProvinceList: [],
      SelectedDppProvince: null,
      stockList: [],
      selectedStock: null,

      selectedProvinceid: null,
      selectedBranchid: null,
      selectedWaitDate: null,
      selectedPrepareDate: null,
      selectedQuotationDate: null,
      selectedInvoiceDate: null,
      selectedReceiptDate: null,
      selectedAllOrdersDate: null,
      selectedMarketBatchDate: null,
      selectedPurchaseMarketPrepareID: null,
      selectedDate: null,
      selectedContractID: null,
      selectedPurchaseID: null,
      selectedPurchaseLOCKED: null,
      isNewB2B: null,
      waitdetaillist: [],
      preparedetaillist: [],
      preparecount: [],

      quotationdetaillisttotal: [],
      quotationdetaillist: [],
      quotationdetaillistfull: [],
      quotationdetaillistsome: [],
      quotationdetaillistzero: [],

      invoicedetaillisttotal: [],
      invoicedetaillist: [],
      invoicedetaillistfull: [],
      fullname: null,
      invoicedetaillistsome: [],
      invoicedetaillistzero: [],
      invoiceTotal: 0,

      receiptdetaillist: [],
      receiptdetaillisttotal: [],
      receiptdetaillistfull: [],
      receiptdetaillistsome: [],
      receiptdetaillistzero: [],

      profitdetaillist: [],

      allordersdetaillist: [],
      marketbatchdetaillist: [],
      printdetaillist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/"
          : "http://localhost/agrilao-manager-v2/api/uploads/",

      productphotopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "https://agrilao.com/manager-main/api/uploads/products/",

      quotationup: 0,
      contractProgress: 0,
      enableprepareedit: 0,
      enablequotationedit: 0,
      enableinvoiceedit: 0,
      enablemarketorderedit: 0,
      submitData: [],
      submitType: null,
      printtype: null,

      b2bproductsearch: null,
      b2bproductTypeId: null,

      b2bproductsearchm: null,

      startOrderDate: null,
      endOrderDate: null,

      startProfitDate: null,
      endProfitDate: null,

      selectedstartProfitDate: null,
      selectedendProfitDate: null,

      startProductPriceDate: null,
      endProductPriceDate: null,

      startMarketBatchDate: null,
      endMarketBatchDate: null,

      activeSub2TabMarketOrder: 0,
      startMarketOrderDate: null,
      endMarketOrderDate: null,

      b2bphoneno: null,
      b2bname: null,
      companytype: null,
      b2bprovince: null,
      b2bdistrict: null,
      b2bvillage: null,

      allOrdersB2BName: null,
      marketBatchB2BName: null,

      allOrderStatusList: [
        { STATUS: "ALL", NAME: "ALL" },
        { STATUS: "1", NAME: "Prepare" },
        { STATUS: "2", NAME: "Quotation" },
        { STATUS: "3", NAME: "Invoice" },
        { STATUS: "4", NAME: "Receipt" },
      ],
      selectedAllStatus: null,
      selectedAllOrderCustomer: null,
      selectedAllProfitCustomer: null,
      selectedAllProfitStatus: null,
      
      selectedProductPriceProduct: null,
      selectedAllProfitProduct: null,

      selectedProductType: null,
      topProductTypeList: [],
      topProductUsage: [],

      selectedAllproductid: null,

      hasSomeUnSubmitPurchase: null,

      productB2BSTATUS: null,
      productssearch: [],
      filteredProducts: [],

      preparedate: null,
      isModalOpen: false,
      allorderstatus: null,

      currentDate: null,

      allMarketBillDateList: [],
      allMarketBillDateDetail: [],
      originalMarketBillDateDetail: [],
      purchaserProduct:[],
      allMarketBillDateDetailOrderbycustomer: [],
      allMarketBillDateDetailOrder: [],
      allMarketBillDateDetailPurchaserProduct: [],
      marketProductTempQuantity: 0,
      productMarketID: 0,
      allMarketBillDateDetailProduct: [],
      marketList: [],
      selectedMarketBatchDetailDate: null,
      selectedMarketBatchID: null,
      selectedProductid: null,
      selectedProductUnit: null,
      selectedProductQuantity: null,

      allmarketorderdate: [],
      marketorderdatedetail: [],
      marketorderdatedetailproduct: [],

      selectedMarketOrderBatchID: null,
      selectedMarketOrderDate: null,
      selectedMarketOrderMarketID: null,
      selectedMarketOrderMarketname: null,

      isSaveMarketButton: true,
      marketbatchstatus: null,
      selectedBatchid: null,

      quotationmarketbatchstatus: [],

      ordercompanylist: [],

      show: null,
      showm: null,

      MARKETQUANTITY: 0,
      SELECTEDMARKET: [],

      amountOptions: Array.from({ length: 20}, (_, index) => ({
        value: index + 1,
        text: (index + 1).toString()
      })),  

      amountSub: Array.from({ length: 200}, (_, index) => ({
        value: index,
        text: (index).toString()
      })),  


      buylist: [],

      checkedValue: "0",
      productsub_list: [],

      
      buyListProductTypeList:[],
      selectedBuyListProductType: null,
      buyListProductList:[],
      selectedBuyListProduct: null,
      buyListProductSubList: [],
      selectedBuyListProductSub: null,

      b2btype: null,
      selectedSubB2B: null,
      subB2BList: [],
      
      profitDateDetailList: [],
      selectedProfitCompany: null,
      selectedProfitPurchaseID: null,
      selectedProfitStatus: null,

      profitStatusList: [
        { ID: "2", NAME: "ລໍຖ້າຮັບເຄື່ອງ" },
        { ID: "3", NAME: "ລໍຖ້າຊຳລະ" },
        { ID: "4", NAME: "ຊຳລະແລ້ວ" },
      ],
      productPriceProductList: [],
      profitAllProductList: [],
      orderByList: [
        { ID: "1", NAME: "ຕາມສິນຄ້າ" },
        { ID: "2", NAME: "ຕາມຜູ້ຮັບຜິດຊອບ" },
        { ID: "3", NAME: "ຕາມຮ້ານ" },
        { ID: "4", NAME: "ຕາມ Vender" }
      ],

      companyByList: [
        { ID: "1", NAME: "ຕາມສິນຄ້າ BatchID" },
        { ID: "2", NAME: "ຕາມເສັ້ນທາງ" }
      ],
      selectedCompanyby: null,

      selectedOrderby: null,
      orderBySet: 1,

      isQuotationChangeDate: false,
      quotationDate: null,
      checkmarketAllProduct : 0,
      checkmarketBuyProduct : 0,

      profitSelectedB2BUSERNAME: null,

      subProductPromotionList: [],
      promotionList: [],

      stockTypeList: [
        { ID: 1, NAME: "ຂາເຂົ້າ" },
        { ID: 2, NAME: "ຂາອອກ" }
      ],
      selectedStockType: [],
      isStockIn: 1,
      stockDate: null,
      stockStartDate: null,
      stockEndDate: null,

      selectedStockProduct: [],
      stockProductSub: [],
      selectedStockProductAmount: 0,
      selectedStockProductAmountOut: 0,
      selectedStockProductTotal: 0,
      selectedVender: [],
      stockVenderList: [],

      stockinHistory: [],
      stockOutHistory:[],

      selectedMarketUser: [],
      selectedMarketUserList: [],

      stockRemain: [],

      priceModelType: 1,
      checkProductList: [],

      selectedMarket: null,

      b2bproductIsCliamedList: [
        "Normal" ,
        "Cliam" 
      ],  

      selectedIsCliamed: [],      
      // selectedIsCliamed: this.b2bproductIsCliamedList[0],        
      countBuyHistoryAmount1: 0,
      countBuyHistoryAmount2: 0,

      paymentStatus: 0,

      receiptDateTime: null,

      selectedPaymentType: null,
      paymentTypeList: [
        { ID: 1, NAME: "ບິນດຽວ" },
        { ID: 2, NAME: "ບິນລວມ" }
      ],

      isManyBill: 0,

      selectedBank: null,
      bankList: [
        { ID: 1, NAME: "BCEL" },
        { ID: 2, NAME: "LDB" },
        { ID: 3, NAME: "JDB" },
        { ID: 4, NAME: "LVB" },
        { ID: 5, NAME: "SCB" },
        { ID: 99, NAME: "ເງິນສົດ" },
        { ID: 100, NAME: "ອື່ນໆ" },
      ],

      paymentReceiptNo: null,
      selectedFile: null,
      url: "uploadreceiptimage", // function name in api site
      photoname: null,
      photopath_receipt:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/paymentreceipt/"
          : "http://localhost/agrilao-manager-v2/api/uploads/paymentreceipt/",
      photopreview: null,

      receiptdata: [],
      isPopupVisible: false,
      popupImgSrc: '',
      billList: Array(10).fill(''),

      selectedPaymentDateType: null,
      paymentDateType: [
        { ID: 1, NAME: "ວັນທີສັ່ງສິນຄ້າ" },
        { ID: 2, NAME: "ວັນທີຊຳລະເງິນ" },
      ],
      startPaymentDate: null,
      endPaymentDate: null,

      startB2BPaymentDate: null,
      endB2BPaymentDate: null,

      b2bPaymentCompany: null,
      b2bPaymentStartDate :null,
      b2bPaymentEnddate : null,

      allquotationdatelist: [],
      isAllQuotation: 0,

      isNumberEdit: 0,

      receiveno: null,

      iskarghuptoaccount: 0,

      invoiceAccountStatus: 0,

      productSearch: null,

      selectedBuyVender: null,
      buyVenderList: [],
      selectedPurchaser: null,
      purchaserList: [],

      countmarketbatch: 0,

          
    }; 
  },
  methods: {  
    asignMarketByVender_temp(){
      if(this.selectedBuyVender == null || this.selectedPurchaser == null){
        this.$swal("ເລືອກໃຫ້ຄົບຖ້ວນ ", "error");
        return false;
      }
      const loadingComponent = this.$loading.open({});
    
      var params = {
        marketbatchid: this.selectedMarketBatchID,    
        redate: this.selectedMarketBatchDate,
        data: this.allMarketBillDateDetail,
        venderid: this.selectedBuyVender.ID,
        purchaserid: this.selectedPurchaser.ID,
        username: this.username,         
      };

      // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
      // console.log("asignMarketByVender_temp params: " + JSON.stringify(params))  
      RestAPI.asignMarketByVender_temp(params)
      .then((res) => {
        params = [];

        if(res.data.code=="01"){
          this.$swal("ບາງລາຍການ ຖືກມອບບາງສ່ວນ " , "", "warning");
        }

        // this.selectedBuyVender = null;
        // this.selectedPurchaser = null;
        this.marketBillDetail(this.selectedMarketBatchID,4);
        loadingComponent.close();
        
        })     
      .catch((error) => {
        loadingComponent.close();
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

          

    },
    onSelectedBuyVender() {
      this.allMarketBillDateDetail = [];
      if (this.selectedBuyVender) {
        // Filter the list based on selected Vender
        this.allMarketBillDateDetail = this.originalMarketBillDateDetail.filter(item => 
          item.VENDERNAME === this.selectedBuyVender.NAME
        );
      } else {
        // If no Vender selected, show all data
        this.allMarketBillDateDetail = [...this.originalMarketBillDateDetail];
      }
    },
    searchAllProductMarket(){
      this.productSearch = null;  
      this.marketBillDetail(this.selectedMarketBatchID, 1);
    },

    searchStockProductMarket(){
      this.productSearch = null;  
      this.marketBillDetail(this.selectedMarketBatchID, 5);
    },
    
    searchProductMarket(){
      this.marketBillDetail(this.selectedMarketBatchID, 1);
    },
    
    gotoJoinBillB2Blist(){
      this.isAllQuotation = 0;
    },
    getQuotationDateList(){
      this.isAllQuotation = 1;
      // console.log("startdate: "+ this.dateFormatterYYYYMMDD(this.startMarketBatchDate))     
      // console.log("enddate: "+ this.dateFormatterYYYYMMDD(this.endMarketBatchDate))

      const loadingComponent = this.$loading.open({});  
      
      RestAPI.getQuotationDateList(this.dateFormatterYYYYMMDD(this.startMarketBatchDate), this.dateFormatterYYYYMMDD(this.endMarketBatchDate)) 
          .then((res) => {
            this.allquotationdatelist =  res.data;     
            loadingComponent.close();
            // console.log("this.allquotationdatelist 01: " + JSON.stringify(this.allquotationdatelist[0].full.length))     
            // console.log("this.allquotationdatelist: " + JSON.stringify(this.allquotationdatelist))   
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
        });
    },

    

    onSelectedOrderby(){
      this.selectedPurchaser = null;
      this.selectedBuyVender  = null;
      this.countmarketbatch = 0;
      this.orderBySet = this.selectedOrderby.ID;
      this.marketBillDetail(this.selectedMarketBatchID, this.selectedOrderby.ID)
    },

    onSelectedCompanyby(){
      this.companyBySet = this.selectedCompanyby.ID;
      this.allMarketBatchStatus(this.companyBySet)
    },

    
    asignMarket(data){
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            data: data,
            marketbatchid: this.selectedMarketBatchID,
            redate: this.selectedMarketBatchDate,
            username: this.username,
          };

          // console.log("data: " + JSON.stringify(data))
          // console.log("params: " + JSON.stringify(params))
    
          const loadingComponent = this.$loading.open({});
          RestAPI.asignMarket(params)  
            .then(() => {
              loadingComponent.close();
              this.marketBillDetail(this.selectedMarketBatchID,1);
              this.orderBySet = 1;
              this.selectedOrderby = null;
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              
             })
            .catch((error) => {
              loadingComponent.close();
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    asignMarket_temp(data, purchaserid){
      // const loadingComponent = this.$loading.open({});

      var params = [];   
      
      params = {
        marketbatchid: this.selectedMarketBatchID,    
        redate: this.selectedMarketBatchDate,
        productid: data.PRODUCTID,  
        marketid: purchaserid,  
        quantity: data.QUANTITY,
        wantquantity: data.QUANTITY, 
        username: this.username,           
      };

      // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
      // console.log("asignMarket_temp params: " + JSON.stringify(params))  
      RestAPI.asignMarket_temp(params)
      .then((res) => {
        // loadingComponent.close();

        if(res.data.code=="01"){
          this.$swal("ໃນສາງມີພຽງ: " + res.data.responseData.amount, "", "warning");  
        }else if(res.data.code=="03"){
          this.$swal("ບໍ່ມີສິນຄ້າໃນສາງ", "", "warning");  
          return false;
        }else if(res.data.code=="04"){
          this.$swal("ສາງມີເຄື່ອງບໍ່ພໍຂັ້ນຕ່ຳ", "", "warning");  
          return false;
        }

        params = [];  
        this.marketBillDetail(this.selectedMarketBatchID,1);
         
        
        })     
      .catch((error) => {
        // loadingComponent.close();
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

          
    },

    asignMarket_temp_inDetail(data, index){        
      const loadingComponent = this.$loading.open({});  
      var params = [];  
      params = {
        marketbatchid: this.selectedMarketBatchID,
        redate: this.selectedMarketBatchDate,
        productid: data.PRODUCTID,  
        marketid: data.SELECTEDMARKET.ID,  
        quantity: data.MARKETQUANTITY,
        wantquantity: data.QUANTITY,
        index: index,
        username: this.username,       
      };

      this.allMarketBillDateDetailOrder[index].SELECTEDMARKET = [];      

      // console.log("data: " + JSON.stringify(data));
      // console.log("asignMarket_temp params: " + JSON.stringify(params))  
      RestAPI.asignMarket_temp(params)
      .then((res) => {
        loadingComponent.close();     
        params = [];
        // console.log("res.data: " +JSON.stringify(res.data))
       

        if(res.data.code=="01"){
          this.$swal("ໃນສາງມີພຽງ: " + res.data.responseData.amount, "", "warning");
      
        }else if(res.data.code=="02"){
          this.$swal("ມອບເກີນຈຳນວນ", "-", "error");
          return false;
        }else if(res.data.code=="03"){
          this.$swal("ບໍ່ມີສິນຄ້າໃນສາງ", "", "warning");  
          return false;
        }else if(res.data.code=="04"){
          this.$swal("ສາງມີເຄື່ອງບໍ່ພໍຂັ້ນຕ່ຳ", "", "warning");  
          return false;
        }

        this.marketBillDetail(this.selectedMarketBatchID,1);
        this.joinOrderDetail(this.selectedMarketBatchID, this.selectedPurchaseMarketPrepareID, this.selectedProductid, this.MARKETQUANTITY , this.selectedMarketBatchDate)
        
        })     
      .catch((error) => {
        loadingComponent.close();    
        console.log(error);
        if (error == "Error: Request failed with status code 400") {
          this.$swal("Check Input Data", "", "error");
        } else {
          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
        }
      });

      
    },

    cancelAsignMarket_temp(data, type){
       const loadingComponent = this.$loading.open({});
       var params = [];
       params = {
          marketbatchid: this.selectedMarketBatchID,  
          redate: this.selectedMarketBatchDate,
          productid: data.PRODUCTID,
          quantity: data.QUANTITY,
          username: this.username,     
        };

        // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
        // console.log("params: " + JSON.stringify(params))  
        RestAPI.cancelAsignMarket_temp(params)  
        .then(() => {
          loadingComponent.close();    
          params = [];
          this.marketBillDetail(this.selectedMarketBatchID,1);
          if(type==2){
            this.activeSub3TabJoinOrder = 1;
            this.joinOrderDetail(this.selectedMarketBatchID, this.selectedPurchaseMarketPrepareID, this.selectedProductid, this.MARKETQUANTITY , this.selectedMarketBatchDate)
          }
          
          })     
        .catch((error) => {
          loadingComponent.close();    
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelPurchaserDetailByID(ID, PRODUCTID, MARKETBATCHID, QUANTITY){


      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
            var params = {
            productid: PRODUCTID,
            detailid: ID,
            marketbatchid: MARKETBATCHID,
            quantity: QUANTITY,
            username: this.username,     
          };

          // console.log("this.SELECTEDMARKET.ID: " + JSON.stringify(data.SELECTEDMARKET.ID))
          // console.log("params: " + JSON.stringify(params))  
          RestAPI.cancelPurchaserDetailByID(params)  
          .then(() => {
            this.marketBillDetail(this.selectedMarketBatchID,1);
            this.activeSub3TabJoinOrder = 0;           
            
            })     
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }  
          });
        }
      });
    
        
    },

    joinOrderDetail(batchid, purchasemarketprepareid, productid, quantity, selectedMarketBatchDate, unit=null){
      this.activeSub3TabJoinOrder = 1;
      this.selectedBatchid = batchid;
      this.selectedPurchaseMarketPrepareID = purchasemarketprepareid; 
      this.selectedProductid = productid;
      this.selectedProductUnit = unit != null ? unit : this.selectedProductUnit;
      this.MARKETQUANTITY = quantity;
      this.selectedMarketBatchDate = selectedMarketBatchDate; 
      
      this.selectedProductQuantity = quantity;
      
      RestAPI.joinOrderDetail(this.username, batchid, productid)
        .then((res) => {
          // console.log("joinOrderDetail res.data: "+ JSON.stringify(res.data))  
          this.allMarketBillDateDetailOrderbycustomer = res.data.orderbycustomer;
          this.allMarketBillDateDetailOrder = res.data.order;
          this.marketProductTempQuantity = res.data.purchasemarkettemp_quantity.QUANTITY_TEMP
          this.productMarketID = res.data.purchasemarkettemp_quantity.MARKETID
          this.allMarketBillDateDetailPurchaserProduct = res.data.purchaserproduct;
          this.marketList = res.data.market;
          // this.allMarketBillDateDetailProduct = res.data;
          // console.log("res.data: " + JSON.stringify(res.data)) 

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },

    getMarketOrderDetail(batchid, redate,marketid, marketname){
      this.activeSub2TabMarketOrder = 1;
      this.selectedMarketOrderBatchID = batchid;
      this.selectedMarketOrderDate = redate;
      this.selectedMarketOrderMarketname = marketname;
      this.selectedMarketOrderMarketID = marketid;

      RestAPI.getMarketOrderDetail(batchid, redate,marketid)
        .then((res) => {
          this.marketorderdatedetail = res.data;

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getMarketOrderDate(){},
    // getMarketOrderDate(){
    //   RestAPI.getMarketOrderDate(
    //     this.dateFormatterYYYYMMDD(this.startMarketOrderDate),
    //     this.dateFormatterYYYYMMDD(this.endMarketOrderDate)
    //   )
    //     .then((res) => {
    //       this.allmarketorderdate = res.data.marketorderdate;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },

    saveMarketforMarketBill(){
     
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            purchasemarketprepareid: this.selectedPurchaseMarketPrepareID,
            productid: this.selectedProductid,
            marketbilldetail: this.allMarketBillDateDetailOrder,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params))  
          RestAPI.saveMarketforMarketBill(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.marketBillDetail(this.selectedMarketBatchID,1)
              this.joinOrderDetail(this.selectedBatchid,this.selectedPurchaseMarketPrepareID,this.selectedProductid, this.MARKETQUANTITY,this.selectedMarketBatchDate);
              this.allMarketBatchStatus(); 
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    confirmMarketforMarketBill(){
     
     this.$swal({
       title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
       showCancelButton: true,
       showCloseButton: true,
       confirmButtonText: "ຕ້ອງການ",
       cancelButtonText: "ບໍ່ຕ້ອງການ",
       confirmButtonColor: "#d33",
       cancelButtonColor: "#3085d6",
     }).then((result) => {
       if (result.value) {
         var params = {
           batchid: this.allMarketBillDateDetail[0].MARKETBATCHID,
           username: this.username,  
         };
         // console.log("params: " + JSON.stringify(params))  
         RestAPI.confirmMarketforMarketBill(params)
           .then(() => {
             this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
             this.marketBillDetail(this.selectedMarketBatchID)
             this.getMarketOrderDate();  
             this.allMarketBatchStatus();
             
            })
           .catch((error) => {
             console.log(error);  
             if (error == "Error: Request failed with status code 400") {
               this.$swal("Check Input Data", "", "error");
             } else {
               this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
             }
           });
       }
     });
   },

    marketBillDetail(batchid, orderby){

      const loadingComponent = this.$loading.open({});  
      
      this.selectedMarketBatchID = batchid;
      // this.allMarketBillDateDetail = [];

      var key = this.productSearch == null ? 0 : this.productSearch;


      var params = {
        batchid: batchid,
        username: this.username,
        orderby: orderby,  
        search: key
      };

      // console.log("productSearch : " + JSON.stringify(this.productSearch))
      // console.log("params : " + JSON.stringify(params))
      
      this.originalMarketBillDateDetail = [];
      this.allMarketBillDateDetail = [];

      RestAPI.getallMarketBatchDetail(params)  
        .then((res) => {
          // console.log("res.data.detail : " + JSON.stringify(res.data.detail[0].MARKETASSIGNSTATUS))
          
          loadingComponent.close();
          if(res.data.detail.length > 0){
            this.allMarketBillDateDetail = res.data.detail;
            if(orderby ==4){
              this.originalMarketBillDateDetail = res.data.detail;
              this.buyVenderList =res.data.venderlist;
              this.purchaserList =res.data.purchserlist;
              this.countmarketbatch = res.data.countmarketbatch;
              if(this.selectedBuyVender !=null){
                this.onSelectedBuyVender();
              }
            }
            // console.log("allMarketBillDateDetail : " + JSON.stringify(res.data.detail))  

            this.purchaserProduct = res.data.purchaser;
            this.checkmarketAllProduct = res.data.checkmakretproduct.ALLPRODUCT;
            this.checkmarketBuyProduct = res.data.checkmakretproduct.BUYPRODUCT;
  
            this.marketbatchstatus = res.data.detail[0].MARKETASSIGNSTATUS;
            this.marketList = res.data.market;

            this.activeSub2TabMarketBatch = 3;  
          }else{
            this.$swal("ບໍ່ພົບຂໍ້ມູນ", "-", "error");
            return false;
          }
            

        })
        
        .catch((error) => {
          loadingComponent.close();
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

    },

    allMarketBatchStatus( byroute = 0) {
      // this.b2bname = null;
      // this.activeSub2TabMarketBatch = 0;
      this.marketbatchdetaillist = [];
      this.selectedMarketBatchDate = null; 
      
      const loadingComponent = this.$loading.open({});
                
      RestAPI.getallMarketBatchStatus(
        this.dateFormatterYYYYMMDD(this.startMarketBatchDate),
        this.dateFormatterYYYYMMDD(this.endMarketBatchDate), byroute
      )
        .then((res) => { 
          loadingComponent.close();


          this.allquotationformarketdatelist = res.data.allquotationformarket;
          this.allMarketBillDateList = res.data.allmarketbilldate;
        })
        .catch((error) => {
          loadingComponent.close();


          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    joinMarketBatch(type, data){
      // console.log("data: "+ JSON.stringify(data))
      // 0 no action , 1 join 
      if(type==1){
          this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              purchaseid: data.PURCHASEID,
              b2busername: data.B2BUSERNAME,
              redate: data.REDATE,
              username: this.username,
            };
            // console.log("data: " + JSON.stringify(data))
            const loadingComponent = this.$loading.open({});
            RestAPI.joinMarketBatchOrder(params)
              .then(() => {
                loadingComponent.close();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.allMarketBatchStatus(); 
                
              })
              .catch((error) => {   
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
       
      }
      else if(type==0){

        this.marketBillDetail(data.MARKETBATCHID, 1);  
        this.selectedMarketBatchDate = data.REDATE;
        // console.log("data.REDATE: " +data.REDATE)
        // console.log("this.selectedMarketBatchDate: " +this.selectedMarketBatchDate)
      }


    },

    cancelJoinMarketBatchOrder(batchid){ 

          this.$swal({
          title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              batchid: batchid,
              username: this.username,
            };
            // console.log("data: " + JSON.stringify(data))
            const loadingComponent = this.$loading.open({});

            RestAPI.cancelJoinMarketBatchOrder(params)
              .then(() => {
                loadingComponent.close();
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                this.allMarketBatchStatus();   
                this.activeSub2TabMarketBatch = 0;
                
              })
              .catch((error) => {
                loadingComponent.close();
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
 


    },
    
    resetData (){
      this.quotationdetaillisttotal = [];
      this.quotationdetaillist = [];
      this.quotationdetaillistfull = [];
      this.quotationdetaillistsome = [];
      this.quotationdetaillistzero = [];

      this.invoicedetaillisttotal = [];
      this.invoicedetaillist = [];
      this.invoicedetaillistfull = [];
      this.invoicedetaillistsome = [];
      this.invoicedetaillistzero = [];

      this.receiptdata = [];
      this.receiptdetaillisttotal = [];
      this.receiptdetaillist = [];
      this.receiptdetaillistfull = [];
      this.receiptdetaillistsome = [];
      this.receiptdetaillistzero = [];

      
    },
    

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },
    loadCheckProduct(){
      RestAPI.loadCheckProduct()    
        .then((res) => {
          // console.log("checkProductList: " + JSON.stringify(res.data));  
          this.checkProductList = res.data;
          setTimeout(() => {
            window.print();
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    },  
    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.currentDate = new Date();
    this.startOrderDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.endOrderDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );
    
    this.startMarketBatchDate = this.startOrderDate;
    this.endMarketBatchDate = this.endOrderDate;  

    this.allMarketBatchStatus();

  },  

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 25%;
}
.column-65 {
  flex: 0 0 75%;
}

.asterisk {
  color: red;
}
  
.table {
  border-collapse: collapse;
  width: 100%;
}

.set-border {
  border: 1px solid #838282;
}

tbody tr:last-child td {
  border-bottom: 1px solid #838282 !important;
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
